import styled from 'styled-components';

export const DashContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
